/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { ResourceType } from '@modules/role-assignments-lib/types'

import type { CSSObject } from '@emotion/react'

export type ApiAccessSelectorProps = {
  onChange: (value: ApiAccessOptions) => void
  defaultValue?: ApiAccessOptions
  includeLabel?: boolean
  fullWidth?: boolean
  cssStyle?: CSSObject
  projectId?: string
  isDisabled?: boolean
  containsCustomRoles?: boolean
  containsNonCloudSpecificProjectRoles?: boolean
  isApiKey?: boolean
  resourceType?: ResourceType
}

export enum ApiAccessOptions {
  CloudApi = 'cloud_api',
  CloudElasticsearchKibanaApi = 'cloud_elasticsearch_kibana_api',
}
